export const RankingsRoutes = {
  leaderboard: 'leaderboard'
}

export const RankingsPaths = {
  leaderboard: `/${RankingsRoutes.leaderboard}`
}
